import React from "react";
import { Line } from "react-chartjs-2";
import { Chart } from "chart.js/auto";

function ExchangeRates() {
  const data = {
    labels: ["Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
    datasets: [
      {
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "rgba(91,37,245, 1)",
        borderWidth: 4.5,
        data: [12.2, 10, 13, 12, 15, 13, 14.5, 11, 13.5, 13, 11],
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        stacked: true,
        grid: {
          display: true,
          color: "rgba(91,37,245, 0.03)",
        },
        ticks: {
          maxTicksLimit: 5,
          min: 9,
          max: 16,
          font: {
            size: 10,
          },
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 10,
          },
        },
      },
    },
    elements: {
      line: {
        tension: 0.4, // Adjust tension to control the wave shape
      },
      point: {
        radius: 0,
      },
    },
  };

  return <Line data={data} options={options} />;
}

export default ExchangeRates;
